<template>

    <div class="admin-support-plan-categories"
         v-if="config.supportPlan">

        <draggable class="dragArea"
                   v-model="config.supportPlan.statementCategories">
            <b-row v-for="(category, categoryIndex) in config.supportPlan.statementCategories">
                <b-col>
                    <b-card no-body class="mb-3">
                        <b-card-header v-b-toggle="`category_${categoryIndex}`">

                            <open-icon name="resize-height" class="drag-handle"></open-icon>
                            <open-icon name="chevron-bottom" v-if="category.visible"></open-icon>
                            <open-icon name="chevron-right" v-if="!category.visible"></open-icon>

                            <label class="mx-2">Category:</label>
                            <b-form-input v-model="category.title" class="card-header-input"/>

                            <div class="float-right">
                                <b-form-checkbox v-model="category.enabled" class="d-inline mr-3">
                                    Enabled
                                </b-form-checkbox>
                                <b-btn variant="default" size="sm"
                                       @click="deleteCategory(category)">
                                    <open-icon name="delete"></open-icon>
                                </b-btn>
                            </div>
                        </b-card-header>
                        <b-collapse :id="`category_${categoryIndex}`"
                                    v-model="category.visible">
                            <b-card-body>

                                <draggable class="dragArea"
                                           v-model="category.subjects">

                                    <b-row class="my-2"
                                           v-for="(subject, subjectIndex) in category.subjects">
                                        <b-col>
                                            <b-card no-body class="mb-3">
                                                <b-card-header v-b-toggle="`subject_${subjectIndex}`">

                                                    <open-icon name="resize-height" class="drag-handle"></open-icon>
                                                    <open-icon name="chevron-bottom" v-if="subject.visible"></open-icon>
                                                    <open-icon name="chevron-right" v-if="!subject.visible"></open-icon>

                                                    <label class="mx-2">Subject:</label>
                                                    <b-form-input v-model="subject.title" class="card-header-input"/>

                                                    <div class="float-right">
                                                        <b-form-checkbox v-model="subject.enabled"
                                                                         class="d-inline mr-3">
                                                            Enabled
                                                        </b-form-checkbox>
                                                        <b-btn variant="default" size="sm"
                                                               @click="deleteSubject(category, subject)">
                                                            <open-icon name="delete"></open-icon>
                                                        </b-btn>
                                                    </div>

                                                </b-card-header>
                                                <b-collapse :id="`subject_${subjectIndex}`"
                                                            v-model="subject.visible">
                                                    <b-card-body>
                                                        <b-row>
                                                            <b-col cols="9">
                                                                <draggable class="dragArea"
                                                                           v-model="subject.strategies">

                                                                    <b-row class="mb-2"
                                                                           v-for="sid in subject.strategies"
                                                                           :key="+sid">
                                                                        <b-col>
                                                                            <b-card no-body class="mb-3">
                                                                                <b-card-header class="py-2">
                                                                                    <open-icon name="resize-height"
                                                                                               class="drag-handle"></open-icon>
                                                                                    {{getStrategy(sid).title}}

                                                                                    <div class="float-right">
                                                                                        <b-btn variant="default"
                                                                                               size="sm"
                                                                                               @click="deleteStrategy(subject, sid)">
                                                                                            <open-icon
                                                                                                    name="delete"></open-icon>
                                                                                        </b-btn>
                                                                                    </div>

                                                                                </b-card-header>
                                                                            </b-card>
                                                                        </b-col>
                                                                    </b-row>
                                                                </draggable>
                                                            </b-col>
                                                            <b-col cols="3">
                                                                <b-btn variant="primary" size="sm"
                                                                       class="float-right mb-3"
                                                                       @click="openAddStrategyModal(subject)">
                                                                    Add Strategy
                                                                </b-btn>
                                                            </b-col>
                                                        </b-row>
                                                    </b-card-body>
                                                </b-collapse>
                                            </b-card>
                                        </b-col>
                                    </b-row>
                                </draggable>

                                <b-btn variant="success" size="sm" class="float-right mb-3"
                                       @click="addSubject(category)">
                                    Add Subject
                                </b-btn>

                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </b-col>

            </b-row>
        </draggable>

        <b-btn variant="success" class="float-right"
               @click="addCategory()">
            Add Category
        </b-btn>

        <div class="clearfix"></div>

        <!-- add strategy modal -->

        <b-modal hide-footer
                 id="add-strategy-modal"
                 title="Add a Strategy">

            <b-form-input placeholder="Search" class="mb-4"
                          v-model="strategySearch">
            </b-form-input>

            <div v-for="(strategy, s) in filteredUnusedStrategies">
                <b-btn variant="success" block class="mb-3"
                       @click="addStrategy(currentSubject, strategy)">
                    {{ strategy.title }}
                </b-btn>
            </div>
            <div v-if="filteredUnusedStrategies.length == 0">
                <b-alert show variant="warning">
                    No additional strategies are available to add to this subject.
                </b-alert>
            </div>

        </b-modal>

    </div>

</template>

<script>

    import Vue from 'vue'
    import draggable from 'vuedraggable'

    export default Vue.extend({
        name: 'AdminSupportPlanCategories',
        components: {
            draggable
        },
        data() {
            return {
                currentSubject: null,
                strategySearch: null
            }
        },
        computed: {
            config() {
                return this.$store.state.config
            },
            filteredUnusedStrategies() {
                if (this.currentSubject) {
                    // if no strategies have been added to the subject, this collection will not exist yet in FB
                    if (!this.currentSubject.strategies) {
                        return this.config.supportPlan.strategies
                    } else {
                        return _.filter(this.config.supportPlan.strategies, (strategy) => {
                            console.log(strategy)
                            return this.currentSubject.strategies.indexOf(strategy.id) == -1 &&
                                (!this.strategySearch ||
                                    strategy.title.toLowerCase().indexOf(this.strategySearch.toLowerCase()) != -1)
                        })
                    }
                } else {
                    return []
                }
            }
        },
        methods: {
            addCategory() {
                this.config.supportPlan.statementCategories.push(this.getNewCategory())
            },
            deleteCategory(cat) {
                if (confirm('Permanently delete this Statement Category?')) {
                    this.config.supportPlan.statementCategories = _.without(this.config.supportPlan.statementCategories, cat)
                }
            },
            addSubject(category) {
                category.subjects.push(this.getNewSubject())
            },
            deleteSubject(category, subject) {
                if (confirm('Permanently delete this Subject?')) {
                    category.subjects = _.without(category.subjects, subject)
                }
            },
            deleteStrategy(subject, sid) {
                if (confirm('Remove this Strategy from this Subject? (This will not delete the Strategy itself)')) {
                    subject.strategies = _.without(subject.strategies, sid)
                }
            },
            getNewCategory() {
                return {
                    title: 'New Category',
                    enabled: false,
                    subjects: [this.getNewSubject()]
                }
            },
            getNewSubject() {
                return {
                    title: 'New Subject',
                    enabled: false,
                    strategies: []
                }
            },
            openAddStrategyModal(subject) {
                this.currentSubject = subject
                this.$bvModal.show('add-strategy-modal')
            },
            addStrategy(subject, strategy) {
                if (!subject.strategies) {
                    Vue.set(subject, 'strategies', [])
                }
                subject.strategies.push(strategy.id)
                this.$bvModal.hide('add-strategy-modal')
            },
            getStrategy(id) {
                const strategy = _.find(this.config.supportPlan.strategies, (s) => s.id == id)
                if (strategy) {
                    return strategy
                } else {
                    return {title: 'DELETED STRATEGY'} // shouldn't happen
                }
            }
        },
    })
</script>
